import { serviceOfferings } from '@/mocks/services';

export default function OfferingsGrid() {
  return (
    <section id="offerings" className="py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary-600 font-semibold text-sm uppercase tracking-widest">Our Services</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-3 text-foreground-950">
            Everything under the IT umbrella
          </h2>
          <p className="text-foreground-600 mt-4">
            One partner for compute, storage, network, virtualization, cloud, and security. No finger-pointing
            between vendors when something goes sideways.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {serviceOfferings.map((s) => (
            <article
              key={s.title}
              className="group bg-background-100 hover:bg-background-50 border border-background-200 hover:border-primary-300 rounded-lg p-8 transition"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition">
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <span className="text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full px-3 py-1 whitespace-nowrap">
                  {s.tagline}
                </span>
              </div>
              <h3 className="text-xl font-bold mt-6 text-foreground-950">{s.title}</h3>
              <p className="text-foreground-600 mt-3 leading-relaxed text-sm">{s.desc}</p>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}